import BaseCreator from './base_creator'

export default class extends BaseCreator {
  #sectionId
  #modelName
  #issuableId
  #issuableType
  #issuableAttribute
  #revisionNumber
  #sectionCode

  constructor(options) {
    super()
    this.#sectionId = options.sectionId
    this.#modelName = options.modelName
    this.#issuableId = options.issuableId
    this.#issuableType = options.issuableType
    this.#revisionNumber = options.revisionNumber
    this.#issuableAttribute = options.issuableAttribute
    this.#sectionCode = options.sectionCode
  }

  getIssuableForm() {
    const mainContainer = this.#prepareContainer()
    return mainContainer
  }

  #prepareContainer() {
    const fieldsContainer = document.createElement('div')
    fieldsContainer.setAttribute('id', `container-${this.#sectionId}`)
    fieldsContainer.appendChild(this.#createRevisionNumber)
    fieldsContainer.appendChild(this.#createIssuableId)
    fieldsContainer.appendChild(this.#createIssuableType)
    fieldsContainer.appendChild(this.#createIssuableAttribute)
    fieldsContainer.appendChild(this.#createSectionCode)

    return fieldsContainer
  }

  get #createRevisionNumber() {
    return this.createHiddenField(`${this.#modelName}[${this.#sectionId}][revision_number]`,
                                  this.#revisionNumber)
  }

  get #createIssuableId() {
    return this.createHiddenField(
      `${this.#modelName}[${this.#sectionId}][issuable_id]`,
      this.#issuableId
    )
  }

  get #createIssuableType() {
    return this.createHiddenField(
      `${this.#modelName}[${this.#sectionId}][issuable_type]`,
      this.#issuableType
    )
  }

  get #createIssuableAttribute() {
    return this.createHiddenField(`${this.#modelName}[${this.#sectionId}][attribute_text]`,
                                  this.#issuableAttribute)
  }

  get #createSectionCode() {
    return this.createHiddenField(`${this.#modelName}[${this.#sectionId}][section_code]`,
                                  this.#sectionCode)
  }
}
